import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_INSTANCE_ACTIONS from '../Actions/ActionTypes';
import { instanceInitState } from './CourseInstanceInitState';

export const instanceReducer = (
  state: IApiJsonResponse<ICourseInstance> = instanceInitState,
  action: IAction<IApiJsonResponse<ICourseInstance>>
): IApiJsonResponse<ICourseInstance> => {
  switch (action.type) {
    case COURSE_INSTANCE_ACTIONS.FETCH_COURSE_INSTANCE:
      return { ...action.payload };

    default:
      return state;
  }
};
